<template>
    <div class="container pb-5">
        <!-- Page title -->
        <div class="pt-5 pb-5">
            <h1 class="m-0">Mijn account</h1>
        </div>
        <!-- End Page title -->

        <!-- My account -->
        <div class="panel" v-if="user">
            <form @submit.prevent="saveAccount">
                <div class="form-group">
                    <label>Naam</label>
                    <input type="text" v-model="accountData.name" class="form-control">
                    <form-errors :errors="errors['name']"></form-errors>
                </div>
                <div class="form-group">
                    <label>E-mailadres</label>
                    <input type="text" v-model="accountData.email" class="form-control">
                    <form-errors :errors="errors['email']"></form-errors>
                </div>
                <div class="row">
                    <div class="col-lg-6">
                        <div class="form-group">
                            <label>Wachtwoord wijzigen</label>
                            <input type="text" v-model="accountData.password" class="form-control">
                            <form-errors :errors="errors['password']"></form-errors>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="form-group">
                            <label>Wachtwoord herhalen</label>
                            <input
                                type="text"
                                v-model="accountData.password_confirmation"
                                class="form-control"
                            >
                        </div>
                    </div>
                </div>
                <div class="d-flex">
                    <button class="btn btn--accent ml-auto" type="submit">Opslaan</button>
                </div>
            </form>
        </div>
        <!-- End My account -->
    </div>
</template>

<script>
export default {
    data() {
        return {
            accountData: this.$store.getters.user,
            savingAccount: false,
            errors: {}
        };
    },
    computed: {
        user() {
            return this.$store.getters.user;
        }
    },
    watch: {
        user(newVal) {
            this.accountData = newVal;
        }
    },
    methods: {
        saveAccount() {
            if (this.savingAccount) {
                return;
            }

            this.savingAccount = true;

            this.$http
                .put("/customers", this.accountData)
                .then(res => {
                    if (res.data.feedback) {
                        this.$root.$emit("notify", {
                            type: res.data.feedback.type,
                            text: res.data.feedback.message
                        });
                        this.savingAccount = false;
                    }
                })
                .catch(err => {
                    console.log(err.response);

                    if (err.response.data) {
                        this.$root.$emit("notify", {
                            type: "error",
                            text: err.response.data.message
                        });

                        this.errors = err.response.data.errors;
                    }

                    this.savingAccount = false;
                });
        }
    }
};
</script>
